export interface SupportedLanguage {
  code: string;
  labelKey: string;
  rtl: boolean;
}

/** App-wide supported locales; extend when adding new product areas. */
export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = [
  { code: 'en', labelKey: 'language.en', rtl: false },
  { code: 'ar', labelKey: 'language.ar', rtl: true },
] as const;

export const DEFAULT_LANGUAGE = 'ar';

export function isSupportedLanguage(code: string | null | undefined): code is string {
  return !!code && SUPPORTED_LANGUAGES.some((l) => l.code === code);
}

export function getLanguageMeta(code: string): SupportedLanguage | undefined {
  return SUPPORTED_LANGUAGES.find((l) => l.code === code);
}
